// ── Bio-Quote — shared formatters/helpers ────────────────────────────────────
// Used by BioQuotePage and the Bio-Quote section of SchoolDeepDivePage.

const MONTHS_SHORT = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']

export function bioEur(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n === 0 ? 0 : n)
}

/** Quote 0..1 → "9,3 %"; null (no food) → "—". */
export function bioPct(quote: number | null | undefined): string {
  if (quote == null || !Number.isFinite(quote)) return '—'
  return `${new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(quote * 100)} %`
}

/** 'YYYY-MM-DD' → 'dd.MM.yyyy' */
export function isoToDe(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/)
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso
}

/** Chart x label per Stufe: Tag dd.MM. · Monat "Jan 26" · Jahr yyyy. */
export function bioPeriodLabel(periode: string, stufe: 'tag' | 'monat' | 'jahr'): string {
  if (stufe === 'tag') {
    const m = periode.match(/^\d{4}-(\d{2})-(\d{2})/)
    return m ? `${m[2]}.${m[1]}.` : periode
  }
  if (stufe === 'monat') {
    const m = periode.match(/^(\d{4})-(\d{2})/)
    return m ? `${MONTHS_SHORT[Number(m[2]) - 1]} ${m[1].slice(2)}` : periode
  }
  return periode.slice(0, 4)
}

/** First day of the month after 'YYYY-MM' as 'YYYY-MM-DD' (exclusive upper bound). */
export function nextMonthStart(period: string): string {
  const [y, m] = period.split('-').map(Number)
  return m === 12 ? `${y + 1}-01-01` : `${y}-${String(m + 1).padStart(2, '0')}-01`
}
